import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import { MdWarning } from 'react-icons/md';

import { Tooltip } from '@shared';
import { intl } from '@shared/localization';

import styles from './PersonWarning.less';

const PersonWarning = ({ person, className }) => {
  const { userId, personShortFullName: personName } = person;
  const shouldShow = !userId;

  return (
    shouldShow && (
      <Tooltip
        title={intl.formatMessage(
          {
            id: 'advancement.PackRoster.noUserIdWarning',
          },
          { personName },
        )}
      >
        <MdWarning className={cn(styles.warningIcon, className)} />
      </Tooltip>
    )
  );
};

PersonWarning.propTypes = {
  person: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default PersonWarning;
